// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ns7lHhJgPesRcCQ7Mqaq{margin-top:9px;overflow:auto}.iDE1LfTqIHcGkQhwfPQP{border-top:1px solid var(--border-neutral-default)}.AKP4V4oue8XMpFMuxK82,.Gr_Rxt71jotd2gEpCELD{margin-top:40px;margin-bottom:10px;display:inline-flex}.KdgMfCQgJgqsAnRvxocg{background:var(--border-neutral-default);height:1px;margin:15.5px 0}.FbRSuytar_gde8Sa4bQW{flex-wrap:wrap;gap:4px;display:flex}.gj_JIJWxmAYCTC6reBRz{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);color:var(--content-primary-primary);border-radius:6px;padding:4px 8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ns7lHhJgPesRcCQ7Mqaq`,
	"topBorder": `iDE1LfTqIHcGkQhwfPQP`,
	"link": `AKP4V4oue8XMpFMuxK82`,
	"title": `Gr_Rxt71jotd2gEpCELD`,
	"divider": `KdgMfCQgJgqsAnRvxocg`,
	"regionsWrap": `FbRSuytar_gde8Sa4bQW`,
	"region": `gj_JIJWxmAYCTC6reBRz`
};
export default ___CSS_LOADER_EXPORT___;
